export default "__VITE_ASSET__MsHM5G9p__"